import React from 'react';
import { activeSeason } from '../config/seasons';

const currentSeasonNewsletters = [
  {
    slug: 'week8-recap',
    title: 'Week 8 Recap: The Race Gets Real',
    date: 'November 3, 2026',
    description: 'Six recaps, playoff and toilet bowl previews, power rankings and Week 9 picks',
    status: 'Read Now',
  },
  {
    slug: 'week7-recap',
    title: 'Week 7 Recap: Six Pull Away. Only Five Get the Easy Door.',
    date: 'October 27, 2026',
    description: 'The top-six sweep, the points-wildcard twist, six recaps, Mickey, season outlooks and Week 8 picks',
    status: 'Read Now',
  },
  {
    slug: 'week6-recap',
    title: 'Week 6 Recap: Six and Oh, Two Mouse Ears, Three Monday Heists',
    date: 'October 20, 2026',
    description: 'Roshik stays perfect, three Monday reversals, six recaps, Mickey, season outlooks, and Week 7 picks',
    status: 'Read Now',
  },
  {
    slug: 'week5-recap',
    title: 'Week 5 Recap: Monday Miracles and a Record Wrecking Ball',
    date: 'October 13, 2026',
    description: 'Two Monday comebacks, Sahil’s record eruption, six recaps, Mickey, power rankings, and Week 6 picks',
    status: 'Read Now',
  },
  {
    slug: 'week4-recap',
    title: 'Week 4 Recap: The Mouse Ears Have Changed Hands',
    date: 'Week 5 pregame edition',
    description: 'Six matchup recaps, Mickey of the Week, season outlooks, and the Week 5 preview',
    status: 'Read Now',
  },
  {
    slug: 'week3-recap',
    title: 'Week 3 Recap: The Scoreboard Has Jokes',
    date: 'September 30, 2026',
    description: 'Six matchup recaps, Mickey of the Week, injury-aware season outlooks, and the Week 4 card',
    status: 'Read Now',
  },
  {
    slug: 'week2-recap',
    title: 'Week 2 Recap: Adams Stole the Ending',
    date: 'September 21, 2026',
    description: 'Adams’ Monday-night comeback, six matchup recaps, injury-aware season outlooks, and the Week 3 card',
    status: 'Read Now',
  },
  {
    slug: 'week1-recap',
    title: 'Week 1 Recap: Rivalry Week Settled',
    date: 'September 16, 2026',
    description: 'Six rivalry verdicts, the decisive players, updated power rankings, and the Week 2 matchups ahead',
    status: 'Read Now',
  },
  {
    slug: 'week1',
    title: 'Week 1: Rivalry Week Preview',
    date: 'September 2026',
    description: 'Every rivalry meeting, scoring trend, margin, and positional edge on the Week 1 card',
    status: 'Read Now',
  },
  {
    slug: 'preseason',
    title: '2026 Preseason Draft Recap',
    date: 'August 2026',
    description: 'Draft coverage, value picks, positional rankings, and team-by-team analysis',
    status: 'Read Now',
  },
];

const CurrentSeasonNewsletterCollection: React.FC = () => {
  return (
    <main className="newsletter-archive-list">
      <div className="archive-header">
        <h1>{activeSeason.shortLabel} Newsletter Archive</h1>
        <p>Every edition of The Amberwood Times from the {activeSeason.label}</p>
      </div>

      <div className="newsletter-grid">
        {currentSeasonNewsletters.map((newsletter) => (
          <article className="newsletter-card available" key={newsletter.slug}>
            <h3>{newsletter.title}</h3>
            <p className="newsletter-date">{newsletter.date}</p>
            <p className="newsletter-description">{newsletter.description}</p>
            <a className="read-btn" href={`${activeSeason.newsletterBasePath}/${newsletter.slug}`}>
              {newsletter.status}
            </a>
          </article>
        ))}
      </div>
    </main>
  );
};

export default CurrentSeasonNewsletterCollection;
